/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  GetProduct200Response,
  GetProduct404Response,
  GetProductByName404Response,
  GetProductsAsGroupName200Response,
  GetProductsAsGroupName400Response,
} from '../models/index'
import {
  GetProduct200ResponseFromJSON,
  GetProduct200ResponseToJSON,
  GetProduct404ResponseFromJSON,
  GetProduct404ResponseToJSON,
  GetProductByName404ResponseFromJSON,
  GetProductByName404ResponseToJSON,
  GetProductsAsGroupName200ResponseFromJSON,
  GetProductsAsGroupName200ResponseToJSON,
  GetProductsAsGroupName400ResponseFromJSON,
  GetProductsAsGroupName400ResponseToJSON,
} from '../models/index'

export interface GetProductRequest {
  id: number
}

export interface GetProductByNameRequest {
  name: string
}

export interface GetProductsAsGroupNameRequest {
  name: string
  ownerSysObjectId?: number
}

/**
 * ProductsApi - interface
 *
 * @export
 * @interface ProductsApiInterface
 */
export interface ProductsApiInterface {
  /**
   * Публичный эндпоинт (без авторизации). Возвращает продукт по идентификатору: поля продукта, список цен с валютами и дочерние продукты.
   * @summary Получить продукт по id
   * @param {number} id Идентификатор продукта
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductsApiInterface
   */
  getProductRaw(
    requestParameters: GetProductRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetProduct200Response>>

  /**
   * Публичный эндпоинт (без авторизации). Возвращает продукт по идентификатору: поля продукта, список цен с валютами и дочерние продукты.
   * Получить продукт по id
   */
  getProduct(
    requestParameters: GetProductRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetProduct200Response>

  /**
   * Публичный эндпоинт (без авторизации). Возвращает продукт по символьному имени (name): поля продукта, список цен с валютами и дочерние продукты.
   * @summary Получить продукт по имени
   * @param {string} name Символьное имя продукта (name)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductsApiInterface
   */
  getProductByNameRaw(
    requestParameters: GetProductByNameRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetProduct200Response>>

  /**
   * Публичный эндпоинт (без авторизации). Возвращает продукт по символьному имени (name): поля продукта, список цен с валютами и дочерние продукты.
   * Получить продукт по имени
   */
  getProductByName(
    requestParameters: GetProductByNameRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetProduct200Response>

  /**
   * Публичный эндпоинт (без авторизации). Активные продукты группы с ценами в валюте по умолчанию; name = all — все активные продукты. Если по ownerSysObjectId найден оплаченный сервисный заказ, продукты соответствующего назначения (order purpose) исключаются из выдачи.
   * @summary Получить продукты группы по имени
   * @param {string} name Символьное имя группы продуктов или all для всех активных продуктов
   * @param {number} [ownerSysObjectId] Идентификатор SysObject: исключает продукты уже оплаченного назначения по этому объекту
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductsApiInterface
   */
  getProductsAsGroupNameRaw(
    requestParameters: GetProductsAsGroupNameRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetProductsAsGroupName200Response>>

  /**
   * Публичный эндпоинт (без авторизации). Активные продукты группы с ценами в валюте по умолчанию; name = all — все активные продукты. Если по ownerSysObjectId найден оплаченный сервисный заказ, продукты соответствующего назначения (order purpose) исключаются из выдачи.
   * Получить продукты группы по имени
   */
  getProductsAsGroupName(
    requestParameters: GetProductsAsGroupNameRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetProductsAsGroupName200Response>
}

/**
 *
 */
export class ProductsApi
  extends runtime.BaseAPI
  implements ProductsApiInterface
{
  /**
   * Публичный эндпоинт (без авторизации). Возвращает продукт по идентификатору: поля продукта, список цен с валютами и дочерние продукты.
   * Получить продукт по id
   */
  async getProductRaw(
    requestParameters: GetProductRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetProduct200Response>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling getProduct().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/products/{id}`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetProduct200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Публичный эндпоинт (без авторизации). Возвращает продукт по идентификатору: поля продукта, список цен с валютами и дочерние продукты.
   * Получить продукт по id
   */
  async getProduct(
    requestParameters: GetProductRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetProduct200Response> {
    const response = await this.getProductRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * Публичный эндпоинт (без авторизации). Возвращает продукт по символьному имени (name): поля продукта, список цен с валютами и дочерние продукты.
   * Получить продукт по имени
   */
  async getProductByNameRaw(
    requestParameters: GetProductByNameRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetProduct200Response>> {
    if (requestParameters['name'] == null) {
      throw new runtime.RequiredError(
        'name',
        'Required parameter "name" was null or undefined when calling getProductByName().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/products/{name}`.replace(
          `{${'name'}}`,
          encodeURIComponent(String(requestParameters['name']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetProduct200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Публичный эндпоинт (без авторизации). Возвращает продукт по символьному имени (name): поля продукта, список цен с валютами и дочерние продукты.
   * Получить продукт по имени
   */
  async getProductByName(
    requestParameters: GetProductByNameRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetProduct200Response> {
    const response = await this.getProductByNameRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Публичный эндпоинт (без авторизации). Активные продукты группы с ценами в валюте по умолчанию; name = all — все активные продукты. Если по ownerSysObjectId найден оплаченный сервисный заказ, продукты соответствующего назначения (order purpose) исключаются из выдачи.
   * Получить продукты группы по имени
   */
  async getProductsAsGroupNameRaw(
    requestParameters: GetProductsAsGroupNameRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetProductsAsGroupName200Response>> {
    if (requestParameters['name'] == null) {
      throw new runtime.RequiredError(
        'name',
        'Required parameter "name" was null or undefined when calling getProductsAsGroupName().'
      )
    }

    const queryParameters: any = {}

    if (requestParameters['ownerSysObjectId'] != null) {
      queryParameters['owner_sys_object_id'] =
        requestParameters['ownerSysObjectId']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/products/groups/{name}`.replace(
          `{${'name'}}`,
          encodeURIComponent(String(requestParameters['name']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetProductsAsGroupName200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Публичный эндпоинт (без авторизации). Активные продукты группы с ценами в валюте по умолчанию; name = all — все активные продукты. Если по ownerSysObjectId найден оплаченный сервисный заказ, продукты соответствующего назначения (order purpose) исключаются из выдачи.
   * Получить продукты группы по имени
   */
  async getProductsAsGroupName(
    requestParameters: GetProductsAsGroupNameRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetProductsAsGroupName200Response> {
    const response = await this.getProductsAsGroupNameRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }
}
